// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","light-grey":"#d4d4d4","divider":"_37dc26Um-oAR4A2wA9YVaT","darkBackground":"_3Fnr5hGQ7F5rbMWnv6SvwY","darkSidebar":"_2wNqcGJESB8_W1tr-UZbJW","lightBackground":"_1w7dj174v_9Vvp-SPk-L82","tooltips":"_2nQksgzFMErNLh9RCOJ90m"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Divider/Divider.css
// module id = 892
// module chunks = 0